import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Close = styled.div`
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  background: ${colorTokens.background.light};
  border-radius: 50%;
  cursor: pointer;
  svg {
    color: ${colorTokens.primary.main};
  }

  &:hover {
    background: #ddebfa;
    svg {
      color: ${colorTokens.primary.light};
    }
  }
`;
